import * as React from 'react';

import { TypographyI18n } from 'components/v2';
import { generateMessageTemplateKey } from 'hooks';
import CancelButtonContainer from '../CancelButtonContainer';

const CancelButtonInitial = () => (
  <CancelButtonContainer disabled>
    <TypographyI18n variant="bW600F14" color="inherit" noWrap>
      {generateMessageTemplateKey('patientLumaBotManageAppointmentCancelAppointmentCompleted')}
    </TypographyI18n>
  </CancelButtonContainer>
);

export default CancelButtonInitial;
